export const SIGN_IN_EVENTS = {
  VIEW_SIGNIN: 'view_signin',
  SELECT_SIGNIN_CONTINUE: 'select_signin_continue',
} as const;
